import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ROICalculator" })
export default class ROICalculator extends Vue {
    public localizer: any = Localizer;
    public quotation: number = null;
    public patient: number = null;
    public treatment: number = null;
    public treatmentCost: number = null;

    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get invoicingPerCustomer() {
        return this.isNumeric(this.treatmentCost * this.treatment);
    }

    get additionalWeeklyTurnover() {
        return this.isNumeric(this.treatmentCost * this.treatment * this.patient);
    }

    get additionalMonthlyTurnover() {
        return this.isNumeric(this.additionalWeeklyTurnover * 4);
    }

    get additionalAnnualTurnover() {
        return this.isNumeric(this.additionalMonthlyTurnover * 12);
    }

    get numberPatientsToAchieveROI() {
        return this.isNumeric(this.quotation / this.invoicingPerCustomer);
    }

    get numberWeeksToAchieveROI() {
        return this.isNumeric(this.quotation / this.additionalWeeklyTurnover);
    }

    @Prop() readonly deviceTitle: string;
    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly requestUrl: string;
    @Prop() readonly message: string;

    public isNumeric(number) {
        if (!isNaN(number) && number != Number.POSITIVE_INFINITY && number != Number.NEGATIVE_INFINITY) {
            return parseFloat(new Number(number + '').toFixed(0));
        } else {
            return 0;
        }
    }
};